// Necesario para hacer el ScrollTrigger.refresh();
// import { gsap } from "gsap";
// import { ScrollTrigger } from "gsap/ScrollTrigger";
// gsap.registerPlugin(ScrollTrigger);

jQuery(document).ready(function($) {

    $("body").on('click', '[data-toggle-accordion]', function (e) {

        e.preventDefault();

        const $accordion = $(this).closest('[data-accordion]');
        const $content = $accordion.find('[data-accordion-content]');
        const content = $content.get(0);
        const isOpen = $accordion.hasClass('open');


        // Espero a que se haga la animación y hago movimiento de scroll
        // Hacerlo solo si existe un ancestro de ficha de producto
        if ($accordion.closest('.product').length) {
            setTimeout(() => {
                // muevo el scroll hasta donde se encuentra el título del acordeón
                const offset = window.innerHeight * 0.3;
                const targetY = $accordion[0].getBoundingClientRect().top + window.scrollY - offset;
                window.scrollTo({
                    top: targetY,
                    behavior: "smooth"
                });
            }, 500);
        }

         // Si hay un ancestro del menú, no dejar nunca todos cerrados
        if ($accordion.closest('.subcategory-group').length) {

            // Hermanos del mismo contenedor
            const $container   = $accordion.parent();
            const $accordions  = $container.children('[data-accordion]');
            const $opened      = $accordions.filter('.open');

            // Helpers para animar
            const openAccordion = ($acc) => {
                const $cnt = $acc.find('[data-accordion-content]');
                const el = $cnt.get(0);
                $cnt.css('height', el.scrollHeight + 'px');
                $cnt.one('transitionend', function () {
                    $cnt.css('height', 'auto');
                });
                $acc.addClass('open');
            };

            const closeAccordion = ($acc) => {
                const $cnt = $acc.find('[data-accordion-content]');
                const el = $cnt.get(0);
                if ($cnt.css('height') === 'auto' || $cnt[0].style.height === 'auto') {
                    $cnt.css('height', el.scrollHeight + 'px');
                    el.offsetHeight; // forzar reflow
                }
                $cnt.css('height', '0px');
                $acc.removeClass('open');
            };

            if (isOpen) {
                // Intentas cerrar uno abierto
                if ($opened.length === 1) {
                    // Es el único abierto -> cerrar este y abrir un hermano para no dejar todos cerrados
                    // Tener en cuenta de que ahora hay alunos items que están hidden en el menú
                    const $next = $accordion.nextAll('[data-accordion]:not(.hidden)').first();;
                    const $target = $next.length ? $next : $accordions.first();

                    // Si solo existe uno en total, no podemos dejarlo cerrado
                    if ($accordions.length === 1) return;

                    closeAccordion($accordion);
                    openAccordion($target);
                } else {
                    // Hay más de uno abierto (por cualquier razón) -> cierra solo este
                    closeAccordion($accordion);
                    // por seguridad, si se quedaran todos cerrados, abre el primero
                    if ($accordions.filter('.open').length === 0) {
                        openAccordion($accordions.first());
                    }
                }
            } else {
                // Abrir uno nuevo -> cierra el resto de HERMANOS y abre este
                $opened.each(function(){ closeAccordion($(this)); });
                openAccordion($accordion);
            }

        } else {
            // Cerrar SOLO los acordeones hermanos (mismo padre)
            $accordion.siblings('[data-accordion].open').each(function () {
                const $otherAccordion = $(this);
                const $otherContent = $otherAccordion.find('[data-accordion-content]');
                const otherContent = $otherContent[0];

                $otherContent.css('height', otherContent.scrollHeight + 'px');
                otherContent.offsetHeight;
                $otherContent.css('height', '0px');
                $otherAccordion.removeClass('open');
            });

            // Abrir/cerrar el acordeón clicado
            if (isOpen) {
                $content.css('height', content.scrollHeight + 'px');
                content.offsetHeight;
                $content.css('height', '0px');
                $accordion.removeClass('open');
            } else {
                $content.css('height', content.scrollHeight + 'px');
                $content.one('transitionend', function () {
                    $content.css('height', 'auto');
                });
                $accordion.addClass('open');
            }
        }

        /* const $icon = $(this).find('[data-lucide]');

        // Rotate the plus 90deg to simulate cross, and 180deg the chevron to put it upside down
        const activeClass = $icon.data('lucide') == 'plus' ? 'rotate-x-90' : 'rotate-x-180';

        if (isOpen) {
            $icon.removeClass(activeClass);
        } else {
            $icon.addClass(activeClass);
        } */

    });
});

